<template>
<v-container>
<app-header  v-if="headerState" :hideTitle="!titleState">
    <span slot="title">Nearby</span>
</app-header>
<v-main>
  <SearchResultList></SearchResultList>
</v-main>
</v-container>
</template>
<style lang="scss" scoped>
  .expanding-search{
    .v-text-field__slot>*{
      cursor: text !important;
    }
  }
</style>

<script>
import SearchResultList from "@/components/page-components/nearby/SearchResultList";
import { mapGetters } from 'vuex';


export default {
  name: 'Nearby',
  props: ['pageParams'],
  components:{
    SearchResultList,
  },
  data(){
    return {
    }
  },
  computed:{
    ...mapGetters([
        'headerState',
        'footerState',
        'titleState'
      ])
  },
  methods:{

  },

}
</script>
